<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'">Số thuê bao</label>
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="searchPhone"
                  :class="rootClass + '__phone-number-input'"
                  v-on:keyup.enter="getSmoSmtHistory"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center">
            <b-button
                :class="rootClass + '__search-btn'"
                class="redButton"
                variant="danger"
                @click="getSmoSmtHistory"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="thongKe">
          <b-col cols="12">
            <div :class="rootClass + '__statistics'">
              <div :class="rootClass + '__stat-item'">
                <span class="label">Tổng số thay đổi:</span>
                <span class="value">{{ thongKe.tongSoThayDoi }}</span>
              </div>
              <div :class="rootClass + '__stat-item'">
                <span class="label">Trạng thái OC:</span>
                <span class="value" :style="{color: thongKe.trangThaiOC === 'Hoạt động' ? 'green' : 'red'}">{{ thongKe.trangThaiOC }}</span>
              </div>
              <div :class="rootClass + '__stat-item'">
                <span class="label">Trạng thái IC:</span>
                <span class="value" :style="{color: thongKe.trangThaiIC === 'Hoạt động' ? 'green' : 'red'}">{{ thongKe.trangThaiIC }}</span>
              </div>
              <div :class="rootClass + '__stat-item'">
                <span class="label">Số lần thay đổi OC:</span>
                <span class="value">{{ thongKe.soLanThayDoiOC }}</span>
              </div>
              <div :class="rootClass + '__stat-item'">
                <span class="label">Số lần thay đổi IC:</span>
                <span class="value">{{ thongKe.soLanThayDoiIC }}</span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <span style="color: red">{{ resultMessage }}</span>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-table'">
            <tr style="height: 3rem;position: sticky">
              <template v-for="(h, i) in tableFields">
                <th
                    :key="h.key"
                    :class="{
                      '--first-th': i === 0,
                      '--last-th': i === tableFields.length - 1,
                    }"
                    :style="{minWidth: h.minWidth || '120px'}"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <template v-for="(r,index) in lichSuData" v-if="showErrSearch===false">
              <tr :key="index" style="color:black;">
                <td>{{ r.STT }}</td>
                <td>{{ r.ThoiGian }}</td>
                <td>{{ r.LoaiDichVu }}</td>
                <td>{{ r.MaDichVu }}</td>
                <td>{{ r.ThaoTac }}</td>
                <td :style="{color: r.TrangThai === 'Hoạt động' ? 'green' : 'red'}">{{ r.TrangThai }}</td>
                <td>{{ r.GhiChu }}</td>
                <td>{{ r.NguoiDung }}</td>
              </tr>
            </template>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormInput,
  BRow,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
  },
  data() {
    return {
      rootClass: "smo-smt-history",
      searchPhone: "",
      regex087: /87\d{7}$/,
      showErrSearch: false,
      lichSuData: [],
      thongKe: null,
      resultMessage: "",
      tableFields: [
        {key: "stt", label: "STT", minWidth: "60px"},
        {key: "thoiGian", label: "Thời gian", minWidth: "150px"},
        {key: "loaiDichVu", label: "Loại dịch vụ", minWidth: "150px"},
        {key: "maDichVu", label: "Mã dịch vụ", minWidth: "100px"},
        {key: "thaoTac", label: "Thao tác", minWidth: "100px"},
        {key: "trangThai", label: "Trạng thái", minWidth: "120px"},
        {key: "ghiChu", label: "Ghi chú", minWidth: "250px"},
        {key: "nguoiDung", label: "Người dùng", minWidth: "120px"},
      ]
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    if (this.searchPhone) {
      this.getSmoSmtHistory();
    }
  },
  methods: {
    formatPhoneNum() {
      if (this.searchPhone.startsWith("0")) {
        this.searchPhone = this.searchPhone.substring(1);
        this.searchPhone = 84 + this.searchPhone;
      }
    },
    getSmoSmtHistory() {
      this.showLoading("block")
      this.formatPhoneNum();

      if (this.regex087.test(this.searchPhone)) {
        useJwt.get('get-subscriber-history-smo-smt/' + this.searchPhone).then((response) => {
          this.showLoading("none")
          if (response.data.code === 200) {
            this.lichSuData = response.data.result.lichSu;
            this.thongKe = response.data.result.thongKe;
            this.resultMessage = response.data.message;
            this.showErrSearch = this.lichSuData.length === 0;
          } else {
            this.showErrSearch = true;
            this.thongKe = null;
            this.resultMessage = "";
            this.$toast.error(response.data.message, {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
          console.log("getSmoSmtHistory", response.data);
        }).catch((error) => {
          this.showLoading("none")
          this.showErrSearch = true;
          this.thongKe = null;
          this.resultMessage = "";
          console.log(error);
        });
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        if (this.searchPhone === "") {
          this.$toast.error("Vui lòng nhập số thuê bao", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.$toast.error("Số thuê bao chưa hợp lệ", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      }
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
  }
};
</script>

<style lang="scss" scoped>
.smo-smt-history {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 80px;
  }

  &__phone-number-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__search-btn {
    border-radius: 40px;
  }

  &__statistics {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  &__stat-item {
    display: flex;
    flex-direction: column;
    
    .label {
      font-size: 13px;
      color: #6c757d;
      font-weight: 500;
    }

    .value {
      font-size: 16px;
      font-weight: 600;
      color: #000;
      margin-top: 5px;
    }
  }

  &__history-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .smo-smt-history {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__statistics {
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>
